import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { socialService } from '../services/socialService';
import { useToast } from '../hooks/use-toast';

const TwitterCallbackPage: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const hasProcessed = useRef(false);
    const { toast } = useToast();

    useEffect(() => {
        console.log("--- TWITTER CALLBACK PAGE TRACE ---");
        console.log("1. Component mounted, parsing URL...");
        console.log("1.1. Full URL:", window.location.href);
        console.log("1.2. Search params:", location.search);
        
        const searchParams = new URLSearchParams(location.search);
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        
        console.log("1.3. Code:", code);
        console.log("1.4. State:", state);
        
        // Prevent double processing on strict mode re-renders or accidental reloads
        if (hasProcessed.current) {
            console.log("Already processed this callback. Navigating away.");
            navigate('/app/dashboard', { replace: true });
            return;
        }
        
        if (code && state) {
            hasProcessed.current = true;
            console.log("2. Code and state found. Clearing URL...");
            // Clear the URL to prevent reprocessing
            window.history.replaceState({}, document.title, location.pathname);

            console.log("3. Code and state found. Calling handleTwitterCallback service...");
            socialService.handleTwitterCallback(code, state)
                .then((response) => {
                    console.log("4. Service call successful. Response:", response);
                    
                    // Show success toast
                    toast({
                        title: 'X Connected!',
                        description: 'Successfully connected your X account. Refresh the page to see your analytics.',
                        variant: 'default',
                    });
                    
                    console.log("5. Navigating to dashboard...");
                    navigate('/app/dashboard', { replace: true });
                })
                .catch((error) => {
                    console.error("4. Service call failed. Error:", error);
                    console.error("4.1. Error details:", error.response?.data);
                    console.error("4.2. Full error response:", error.response);
                    
                    let errorMessage = 'Failed to connect your X account. Please try again.';
                    if (error.response?.data?.detail) {
                        if (Array.isArray(error.response.data.detail)) {
                            errorMessage = error.response.data.detail.map((e: any) => e.msg || e).join(', ');
                        } else {
                            errorMessage = error.response.data.detail;
                        }
                    }
                    
                    toast({
                        title: 'Connection Failed',
                        description: errorMessage,
                        variant: 'destructive'
                    });
                    
                    console.log("5. Error occurred. Navigating to dashboard...");
                    navigate('/app/dashboard', { replace: true });
                });
        } else {
            console.error('3. No code or state found in callback URL. Navigating...');
            navigate('/app/dashboard', { replace: true });
        }
        
        console.log("--- END TWITTER CALLBACK PAGE TRACE ---");
    }, [location, navigate, toast]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-gray-50 dark:from-gray-900 dark:to-slate-900">
            <div className="text-center">
                <div className="w-16 h-16 border-4 border-black dark:border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Connecting to X</h2>
                <p className="text-gray-600 dark:text-gray-400">Please wait while we set up your X connection...</p>
            </div>
        </div>
    );
};

export default TwitterCallbackPage;
